<script>
import ReportHeader from "./ReportHeader";
import PrintView from "./PrintView";
import APIAttendance from "@/mixins/APIAttendance";
export default {
  components: {
    PrintView,
    ReportHeader
  },
  mixins: [APIAttendance],
  data() {
    return {
      dateRange: {
        from: new Date(),
        to: new Date()
      },
      logType: "in",
      contactMode: [""],
      page: 0,
      perpage: 10000,
      filters: false,
      attendanceList: [],
      items: []
    };
  },
  mounted() {
    this.fetchAttendaceDetails();
  },
  computed: {
    today: function() {
      var curr = new Date();
      curr.setDate(curr.getDate() + 1);
      return curr.toISOString().split("T")[0];
    },
    weekFirstDate: function() {
      var curr = new Date();
      var first = curr.getDate() - curr.getDay();
      var firstdate = new Date(curr.setDate(first + 2)); // from monday
      return firstdate.toISOString().split("T")[0];
    },
    weekLastDate: function() {
      var curr = new Date();
      var first = curr.getDate() - curr.getDay();
      var last = first + 6;
      var lastdate = new Date(curr.setDate(last));
      return lastdate.toISOString().split("T")[0];
    }
  },
  methods: {
    printReport: function(headerInfo) {
      console.log(headerInfo);
      localStorage.printItems = JSON.stringify(this.items);
      localStorage.printContactMode = this.contactMode;

      // create print header details
      let printHeaderData = {
        section: {
          top: {
            title: "",
            subtitle: ""
          },
          middle: {
            title: "",
            subtitle: ""
          },
          bottom: {
            subtitle: []
          }
        }
      };

      let company = JSON.parse(localStorage.active_user);

      // top section informations
      printHeaderData.section.top = {
        title: "",
        subtitle: ""
      };

      printHeaderData.section.top.title =
        company.company_name || company.company.name;
      printHeaderData.section.top.subtitle = company.email;

      // middle section informations
      printHeaderData.section.middle = {
        title: "",
        subtitle: ""
      };

      let mode = this.signMode(headerInfo);
      let type = this.contactMode + "s";
      if (this.contactMode === "Staff") {
        type = "Staff";
      }
      printHeaderData.section.middle.title =
        "Attendance Sheet - " + type + " " + mode;
      printHeaderData.section.middle.subtitle =
        mode +
        " details from " +
        headerInfo.from_date +
        " to " +
        headerInfo.to_date;

      // middle section informations
      printHeaderData.section.bottom.subtitle = [];
      printHeaderData.section.bottom.subtitle.push(this.reportGenerateStamp());
      printHeaderData.section.bottom.subtitle.push(
        "Report generated by: edPass"
      );

      localStorage.printHeader = JSON.stringify(printHeaderData);
      let routeData = this.$router.resolve({
        name: "EdpassPrint",
        props: true
      });
      window.open(routeData.href, "_blank");
    },
    reportGenerateStamp: function() {
      return (
        "Report generated on: " +
        new Date().toLocaleDateString() +
        " at " +
        new Date().toLocaleTimeString()
      );
    },
    fetchAttendaceDetails: function() {
      this.handleGet();
    },
    signMode: function(ob) {
      let state = ob.sign_mode;
      return state.length === 0
        ? ""
        : state.length === 2
        ? "Sign In/Out"
        : state[0] === "in"
        ? "Sign In"
        : "Sign Out";
    },
    handleGet: async function() {
      this.dateRange.from = this.$store.state.filterOptions.from_date;
      this.dateRange.to = this.$store.state.filterOptions.to_date;
      this.logType = this.$store.state.filterOptions.sign_mode;

      if (this.logType.length === 0) {
        this.items = [];
        this.$toast.error("Invalid attendance mode selection.", "Error", {
          position: "topCenter"
        });
        return;
      }

      try {
        /*
        let res = await this.historicalList(
          this.contactMode.toLowerCase(),
          this.logType ? this.logType : null,
          this.dateRange.from,
          this.dateRange.to
        );
        */
        // holder_type=&attendance_type=&from_date=2019-08-12&to_date=2019-09-13
        // &page=0&perpage=20&id=&first_name=nim&last_name=&mobile=&key=&class='
        let options = [];
        if (this.dateRange.from && this.dateRange.to) {
          options.push("from_date=" + this.dateRange.from);
          options.push("to_date=" + this.dateRange.to);
        } else if (this.dateRange.from && !this.dateRange.to) {
          options.push("from_date=" + this.dateRange.from);
          options.push("to_date=" + this.dateRange.from);
        } else if (!this.dateRange.from && this.dateRange.to) {
          options.push("from_date=" + this.dateRange.to);
          options.push("to_date=" + this.dateRange.to);
        }

        if (this.contactMode) {
          options.push("holder_type=" + this.contactMode.toLowerCase());
        }
        if (this.logType && this.logType.length != 2) {
          options.push("attendance_type=" + this.logType);
        }

        let fname = this.$store.state.filterOptions.first_name;
        if (fname) {
          options.push("first_name=" + fname);
        }
        let lname = this.$store.state.filterOptions.last_name;
        if (lname) {
          options.push("last_name=" + lname);
        }

        options.push("page=" + this.page);
        options.push("perpage=" + this.perpage);

        let res = await this.filterList(options);
        this.items = res;
      } catch (error) {
        console.log(error);
        this.$toast.error("Cannot get Historical List!", "Error", {
          position: "topCenter"
        });
      }
    }
  }
};
</script>

<style scoped>
.justifybetween {
  display: flex;
  justify-content: space-between;
}
.header {
  text-align: center;
}
.report-info {
  display: flex;
  justify-content: space-between;
}
</style>
